const ABSOLUTE_URL = /^https?:\/\//i;

/**
 * Resolve an endpoint path against the SAP base URL.
 * Absolute values are returned untouched (tolerates legacy data).
 */
export const resolveSapEndpoint = (
  baseUrl?: string | null,
  path?: string | null
): string => {
  const rawPath = String(path ?? "").trim();

  if (ABSOLUTE_URL.test(rawPath)) {
    return rawPath;
  }

  const base = String(baseUrl ?? "").trim().replace(/\/+$/, "");
  const relative = rawPath.replace(/^\/+/, "");

  return relative ? `${base}/${relative}` : base;
};

/**
 * Normalize a stored endpoint value to a path relative to the SAP base URL.
 * If a base URL is pasted, it is stripped; otherwise the value is returned as a
 * path with a leading slash.
 */
export const toRelativeSapPath = (
  baseUrl?: string | null,
  value?: string | null
): string => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const base = String(baseUrl ?? "").trim().replace(/\/+$/, "");

  if (!ABSOLUTE_URL.test(raw)) {
    return raw.startsWith("/") ? raw : `/${raw}`;
  }

  if (base && raw.toLowerCase().startsWith(base.toLowerCase())) {
    const rest = raw.slice(base.length).replace(/^\/+/, "");
    return rest ? `/${rest}` : "";
  }

  // Absolute but not matching the configured base - leave it untouched.
  return raw;
};
